import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import ClockIcon from '@atlaskit/icon/core/clock';

import type {
	ForYouListFilterConfig,
	ForYouQueryHook,
	NavItemConfig,
	RecentsItem,
} from '../../common/types';
import type { Action } from '../object-list-flyout/types';

import { RECENT_TEST_ID } from './constants';
import { messages } from './messages';

export interface RecentProps {
	useRecentItems: ForYouQueryHook<RecentsItem>;
	searchable?: boolean;
	searchPlaceholder?: string;
	filters?: ForYouListFilterConfig[];
	viewAllHref?: string;
	viewAllOnClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
	peek?: boolean;
}

export default function makeRecentNavItem({
	useRecentItems,
	searchable = true,
	searchPlaceholder,
	filters,
	viewAllHref,
	viewAllOnClick,
	peek = false,
}: RecentProps): NavItemConfig {
	const icon = <ClockIcon label="" />;
	const label = <FormattedMessage {...messages.recentLabel} />;

	const filterConfig = filters ? { filters } : undefined;
	const viewAllRecentLabels = <FormattedMessage {...messages.viewAllRecentsLabel} />;
	const actions: Action[] | undefined = viewAllHref
		? [
				{
					elemBefore: <AlignTextLeftIcon label={''} />,
					label: viewAllRecentLabels,
					href: viewAllHref,
					onClick: viewAllOnClick,
				},
			]
		: viewAllOnClick && [
				{
					elemBefore: <AlignTextLeftIcon label={''} />,
					label: viewAllRecentLabels,
					onClick: viewAllOnClick,
				},
			];

	return {
		// todo: Make i18n compatible
		name: messages.recentLabel.defaultMessage,
		icon,
		type: 'object-list-flyout',
		testId: RECENT_TEST_ID,
		label,
		searchPlaceholder,
		filterConfig,
		actions,
		isDefaultOpen: peek,
		isSearchable: searchable,
		useItems: useRecentItems,
	};
}
